// API related actions
export const FETCHING_MASTER_VEHICLES_LIST = '@@toyota/FETCHING_MASTER_VEHICLES_LIST';
export const FETCHED_MASTER_VEHICLES_LIST = '@@toyota/FETCHED_MASTER_VEHICLES_LIST';
export const FETCHED_MASTER_VEHICLES_LIST_FAILED = '@@toyota/FETCHED_MASTER_VEHICLES_LIST_FAILED';
export const FETCHING_MASTER_VEH = '@@toyota/FETCHING_MASTER_VEH';
export const FETCHED_MASTER_VEH = '@@toyota/FETCHED_MASTER_VEH';
export const FETCHED_MASTER_VEH_FAILED = '@@toyota/FETCHED_MASTER_VEH_FAILED';
export const FETCHING_MASTER_VEH_COLOR = '@@toyota/FETCHING_MASTER_VEH_COLOR';
export const FETCHED_MASTER_VEH_COLOR = '@@toyota/FETCHED_MASTER_VEH_COLOR';
export const FETCHED_MASTER_VEH_COLOR_FAILED = '@@toyota/FETCHED_MASTER_VEH_COLOR_FAILED';
export const FETCHING_JDE_PARAMETERS = '@@toyota/FETCHING_JDE_PARAMETERS';
export const FETCHED_JDE_PARAMETERS = '@@toyota/FETCHED_JDE_PARAMETERS';
export const FETCHED_JDE_PARAMETERS_FAILED = '@@toyota/FETCHED_JDE_PARAMETERS_FAILED';
export const FETCHING_CLASSES = '@@toyota/FETCHING_CLASSES';
export const FETCHED_CLASSES = '@@toyota/FETCHED_CLASSES';
export const FETCHED_CLASSES_FAILED = '@@toyota/FETCHED_CLASSES_FAILED';
export const UPDATING_MASTER_VEH = '@@toyota/UPDATING_MASTER_VEH';
export const UPDATED_MASTER_VEH = '@@toyota/UPDATED_MASTER_VEH';
export const UPDATED_MASTER_VEH_FAILED = '@@toyota/UPDATED_MASTER_VEH_FAILED';
export const UPDATING_REJECT_MASTER_VEH = '@@toyota/UPDATING_REJECT_MASTER_VEH';
export const UPDATED_REJECT_MASTER_VEH = '@@toyota/UPDATED_REJECT_MASTER_VEH';
export const UPDATED_REJECT_MASTER_VEH_FAILED = '@@toyota/UPDATED_REJECT_MASTER_VEH_FAILED';
export const CREATING_MASTER_VEH = '@@toyota/CREATING_MASTER_VEH';
export const CREATED_MASTER_VEH = '@@toyota/CREATED_MASTER_VEH';
export const CREATED_MASTER_VEH_FAILED = '@@toyota/CREATED_MASTER_VEH_FAILED';
export const FETCHING_VEHICLE_MASTER_AUDIT = '@@toyota/FETCHING_VEHICLE_MASTER_AUDIT';
export const FETCHED_VEHICLE_MASTER_AUDIT = '@@toyota/FETCHED_VEHICLE_MASTER_AUDIT';
export const FETCHED_VEHICLE_MASTER_AUDIT_FAILED = '@@toyota/FETCHED_VEHICLE_MASTER_AUDIT_FAILED';

// No related api actions
export const DELETE_MASTERVEH_DATA = '@@toyota/DELETE_MASTERVEH_DATA';
export const UPDATE_REQUEST_STATE = '@@toyota/UPDATE_REQUEST_STATE';
export const SAVE_VEHICLE_FILE_REQUEST = '@@toyota/SAVE_VEHICLE_FILE_REQUEST';
export const SAVE_VEHICLE_FILE_SUCCESS = '@@toyota/SAVE_VEHICLE_FILE_SUCCESS';
export const SAVE_VEHICLE_FILE_FAILED = '@@toyota/SAVE_VEHICLE_FILE_FAILED';
export const FETCHING_MASTER_VEHICLE_ATTACHMENTS = '@@toyota/FETCHING_MASTER_VEHICLE_ATTACHMENTS';
export const FETCHED_MASTER_VEHICLE_ATTACHMENTS = '@@toyota/FETCHED_MASTER_VEHICLE_ATTACHMENTS';
export const FETCHED_MASTER_VEHICLE_ATTACHMENTS_FAILED = '@@toyota/FETCHED_MASTER_VEHICLE_ATTACHMENTS_FAILED';
export const SET_IMAGE_FILES = '@@toyota/SET_IMAGE_FILES';
export const SAVE_VEHICLE_FILE_AUDI_REQUEST = '@@toyota/SAVE_VEHICLE_FILE_AUDI_REQUEST';
export const SAVE_VEHICLE_FILE_AUDI_SUCCESS = '@@toyota/SAVE_VEHICLE_FILE_AUDI_SUCCESS';
export const SAVE_VEHICLE_FILE_AUDI_FAILED = '@@toyota/SAVE_VEHICLE_FILE_AUDI_FAILED';
